import { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { ValidatorForm } from "react-material-ui-form-validator";
import ProductPage from '../../routes/admin/ProductsPage'
import SelectedProductList from "../SelectedProductList";
import Tx from "../Tx";
import styles from './AIReportProductsDialog.module.css';

const AIReportProductsDialog = ({ isVisible, onClose, onSave }) => {
    const [selectedProducts, setSelectedProducts] = useState([]);

    const handleSave = () => {
        onSave(selectedProducts);
    }

    const handleSelectProduct = (product) => {
        setSelectedProducts(prevProducts => {
            const index = prevProducts.findIndex(prod => prod._id === product._id);
            if (index === -1) return [...prevProducts, product];

            const newArr = [...prevProducts];
            newArr.splice(index, 1);
            return newArr;
        });
    }

    const handleDeleteSelectedProduct = (product) => {
        setSelectedProducts(prevProducts => prevProducts.filter(p => p._id !== product._id));
    }

    return (
        <Dialog
            open={!!isVisible}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="md"
            scroll='paper'
            fullWidth={true}
        >
            <ValidatorForm
                onSubmit={handleSave}
                onError={errors => console.log(errors)}>

                <DialogTitle id="ai-report-dialog-title">
                    <Tx>Select Products</Tx>
                </DialogTitle>

                <DialogContent style={{ overflow: 'hidden' }} dividers>
                    {/* Selected Product List */}
                    <div className={styles.selectedProductList}>
                        <SelectedProductList
                            selectedProducts={selectedProducts}
                            onDelete={handleDeleteSelectedProduct}
                        />
                    </div>
                    <div style={{ height: '70vh' }}>
                        <ProductPage
                            onSelect={handleSelectProduct}
                            selectedProducts={selectedProducts}
                            readonly
                        />
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
                    <Button disabled={selectedProducts.length === 0} type="submit"><Tx>g.save</Tx></Button>
                </DialogActions>
            </ValidatorForm>
        </Dialog>
    )
}

export default AIReportProductsDialog;